import { useEffect, useState } from "react";
import { Printer, Loader2, Archive, Download } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, saveBlob, fetchBlob } from "@/lib/api";
import { fmtDate, fmtDateTime } from "@/lib/util";
import MonthArchive from "@/components/MonthArchive";

const LABELS = [["invoices", "فاتورة"], ["documents", "مستند"], ["violations", "مخالفة"], ["fee_payments", "دفعة رسوم"], ["trip_photos", "صورة نقلة"], ["notif_files", "مرفق إشعار"]];

export default function ArchiveCard({ bare }) {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/archive/status").then((r) => setS(r.data)).catch(() => setS(false));
  useEffect(() => { load(); }, []);
  if (!s) return null;
  const print = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/archive/print", null, { responseType: "blob" });
      saveBlob(data, `archive-${new Date().toISOString().slice(0, 10)}.pdf`);
      toast.success("تم تجهيز ملف الطباعة");
      load();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const reprint = async (p) => {
    try { saveBlob(await fetchBlob(`/archive/prints/${p.id}/pdf`), `archive-${p.to.slice(0, 10)}.pdf`); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className={bare ? "" : "card p-5 mb-6 border-2 border-brand/20"} data-testid="archive-card">
      <div className="flex flex-wrap items-center gap-4">
        <span className="w-14 h-14 rounded-2xl bg-brand text-white flex items-center justify-center shrink-0"><Archive className="w-7 h-7" /></span>
        <div className="flex-1 min-w-[220px]">
          <b className="text-lg block">طباعة كل المدخلات منذ آخر طباعة</b>
          <span className="text-sm text-slate-500" data-testid="archive-since">{s.since ? `منذ ${fmtDateTime(s.since)}` : "منذ بداية النظام"} — المجموع <b className="text-brand">{s.total}</b>: {LABELS.map(([k, l]) => `${s.counts[k]} ${l}`).join("، ")}</span>
        </div>
        <button data-testid="archive-print-btn" onClick={print} disabled={busy || !s.total} className="btn btn-lg btn-blue">
          {busy ? <Loader2 className="w-6 h-6 animate-spin" /> : <Printer className="w-6 h-6" />}{busy ? "جارِ التجهيز..." : "طباعة الكل PDF"}</button>
      </div>
      <MonthArchive labels={LABELS} />
      {s.prints.length > 0 && (
        <details className="mt-3 text-sm" data-testid="archive-history">
          <summary className="cursor-pointer text-brand font-bold">الطباعات السابقة ({s.prints.length})</summary>
          <div className="mt-2 space-y-1">
            {s.prints.map((p) => (
              <div key={p.id} className="flex items-center justify-between bg-slate-50 rounded-xl px-3 py-2">
                <span>{fmtDate(p.from) || "البداية"} ← {fmtDate(p.to)} • {Object.values(p.counts).reduce((a, b) => a + b, 0)} إدخال • {p.by_name}</span>
                <button data-testid={`archive-reprint-${p.id}`} onClick={() => reprint(p)} className="btn btn-sm btn-ghost"><Download className="w-4 h-4" />تنزيل</button>
              </div>
            ))}
          </div>
        </details>
      )}
    </div>
  );
}
